const AUCTION_STATUSES = {
  PENDING: 1,
  RUNNING_AUCTION: 2,
  NOT_WON_AUCTION: 3,
  WON_AUCTION: 4,
  SECOND_CHANCES: 5,
};

const rnbCustomerApiKey = 'rnb-customer-api-key'
const rnbCustomerShopifyId = 'rnb-customer-shopify-id'
const rnbCustomerId = 'rnb-customer-id'

const customShared = (() => {
  const getCustomerApiKey = () => {
    return sessionStorage.getItem(rnbCustomerApiKey) ?? localStorage.getItem(rnbCustomerApiKey);
  }

  const isImpersonating = () => !!sessionStorage.getItem(rnbCustomerApiKey);

  const getCustomerId = () => {
    // session = impersonate, local = real login
    const id = sessionStorage.getItem(rnbCustomerId) ?? localStorage.getItem(rnbCustomerId);
    return id ? Number(id) : 0;
  }

  const getLocalFullDate = function (date, time) {
    var times = time.split(':');
    var hour = times[0];
    var minute = times[1];
    var second = times[2];

    var resDate = moment(date).add(hour, 'hours').add(minute, 'minutes');

    if (second) {
      resDate.add(second, 'seconds');
    }

    return resDate;
  };

  const getTimerHtmlStr = function (countDownDate) {
    const now = moment().valueOf();
    const distance = countDownDate - now;

    if (distance <= 0) return 'Ended. Processing may take a few minutes';

    const days = distance > 0 ? Math.floor(distance / (1000 * 60 * 60 * 24)) : 0;
    const hours = distance > 0 ? Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) : 0;
    const minutes = distance > 0 ? Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) : 0;
    const seconds = distance > 0 ? Math.floor((distance % (1000 * 60)) / 1000) : 0;

    const momentDate = moment(countDownDate);
    // https://momentjs.com/docs/#/displaying/format/
    if (days >= 1) return `${days} day${days === 1 ? '' : 's'} left (${momentDate.format('ddd, MMM D')})`;
    if (hours >= 1) return `${hours}h:${minutes}m left (${momentDate.format('ddd, hh:mm A')})`;
    if (minutes >= 5) return `<span class="attention">${minutes}m left (${momentDate.format('hh:mm A')})</span>`;
    if (minutes >= 1) return `<span class="attention">${minutes}m:${seconds}s left (${momentDate.format('hh:mm A')})</span>`;
    return `<span class="attention">${seconds} second${seconds === 1 ? '' : 's'} left</span>`;
  };

  const retrieveData = async (path, { method, urlencoded, label, payload, okCodes } = {}) => {
    if (method?.toLowerCase() !== 'get' && isImpersonating()) {
      const msg = `No change allowed while impersonating ${path}`;
      toastr.error(msg);
      console.error(msg);
      throw new Error(msg);
    }
    const options = {
      method,
      headers: {
        'Content-Type': urlencoded ? 'application/x-www-form-urlencoded; charset=UTF-8' : 'application/json',
        // TODO remove when ngrok will not be used
        'ngrok-skip-browser-warning': 'any',
        'Access-Control-Allow-Origin': reefbayAppUrl(),
      },
    };

    if (getCustomerApiKey()) {
      options.headers.Authorization = `Bearer ${getCustomerApiKey()}`;
    }

    if (payload) {
      options.body = urlencoded ? new URLSearchParams(payload).toString() : JSON.stringify(payload);
    }

    return fetch(reefbayAppUrl() + path, options).then(async (res) => {
      if (res.ok) return await res.json();
      if (okCodes?.includes(res.status)) return res.status;

      const err = await res.json();
      throw err;
    }).catch(err => {
      console.error(`${label} error`, err?.status || err);
      toastr.error(`Unable to ${label}`);
      return { error: err?.errors || err?.status || err };
    });
  };

  const postData = async (path, payload, options = {}) => retrieveData(path, {
    ...options,
    payload,
    method: 'post',
  });

  const cacheMap = {};
  const getData = async (path, options = {}) => {
    // TODO need to think how to invalidate cache
    // if (cacheMap[path] && !options.nocache) {
    //   return cacheMap[path]
    // }
    const result = await retrieveData(path, { ...options, method: 'get' });
    //  cacheMap[path] = result
    return result;
  };

  const getWatchList = async () => {
    if (!getCustomerApiKey()) {
      console.log(`missing globalCustomerAPIKey ${getCustomerApiKey()}`);
      return [];
    }
    const result = await getData(`/customer/watchlist/0}`, {
      label: 'get watch list',
      okCodes: [401],
    });
    return result?.watchlists ?? [];
  };

  const HASH_DELIMITER = '-';

  const toHash = (obj) => {
    const hash = Object.entries(obj)
      .filter(([key, val]) => key && val)
      .map(([key, val]) => val ? `${key}${HASH_DELIMITER}${val}` : '')
      .join('/');

    return '#/'.concat(hash);
  };

  const fromHash = () => {
    const hashParts = window.location.hash
      .split('/')
      .filter(part => part && part !== '#')
      .map(part => part.split(HASH_DELIMITER).map(decodeURIComponent));

    return Object.fromEntries(hashParts);
  };

  const loadTemplate = (selector, htmlUrl) => {
    return new Promise((resolve) => {
      $(selector).load(htmlUrl, () => resolve());
    });
  };

  const roundNum = (base, increment = 0, unit = 0) => {
    return typeof base === 'number'
      ? Math.round((base * 100) + (increment * unit * 100)) / 100
      : 0;
  };

  const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

  const setLoading = (selector) => {
    $(selector).addClass('buy_now_disabled');
  };

  const unsetLoading = (selector) => {
    $(selector).removeClass('buy_now_disabled');
  };

  const loadUiScript = (name) => {
    const script = document.createElement('script');
    const config = hostConfig[name] ?? hostConfig.default;
    const src = `${config[location.origin]}/${name}/assets.js?t=${Date.now()}`;

    console.log(`loading ${name} for ${location.origin}: ${src}`);

    script.src = src;
    script.type = 'module';

    document.body.appendChild(script);
  };

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });

  const formatCents = (cent) => currencyFormatter.format((cent ?? 0) / 100);

  const formatDollars = (dollar) => currencyFormatter.format(dollar ?? 0);

  const toDollars = (cents) => (cents ?? 0) / 100;

  const toCents = (dollars) => (dollars ?? 0) * 100;

  return {
    setLoading,
    unsetLoading,
    getLocalFullDate,
    getTimerHtmlStr,
    postData,
    getData,
    getWatchList,
    toHash,
    fromHash,
    loadTemplate,
    roundNum,
    sleep,
    loadUiScript,
    formatCents,
    formatDollars,
    toDollars,
    toCents,
    getCustomerApiKey,
    getCustomerId,
  };
})();
